import {Modal} from 'react-bootstrap';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {StyledModal} from '../../common/shared/modal.styled';
import user from '../../images/newDesign/user.svg';
import phone from '../../images/newDesign/phone.svg';
import mail from '../../images/newDesign/mail.svg';

const NotificationsModal = styled(StyledModal)`
  .modal-dialog {
    max-width: 980px;
  }

  .modal-header {
    padding: 15px;
    background: linear-gradient(90deg, #6895FF 1.59%, #8C5CFF 100%);
    border: none;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    color: #fff;
  }
  
  .data {
    display: flex;
    justify-content: space-between;
    text-align: initial;
    color: ${props => props.theme.textLight};
    .data-item div {
        height: 24px;
        margin: 0 0 7px 0;
    }
    h3 {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      img {
        margin-inline-end: 15px;
      }
    }
    .type {
      margin-left: 20px;
    }
  }
`;

export default function TenantDetailsModal({show, onHide, tenantData = {}}) {
    const {t} = useTranslation();

    return (
        <NotificationsModal
            centered
            show={show}
            onHide={onHide}
        >
            <span
                className={'modal-close'}
                onClick={onHide}
            >
                &#215;
            </span>
            <Modal.Header>
                <Modal.Title>{`${t('notifications.tenantDetailsFor')} ${tenantData.apartmentNumber}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'data'}>
                    <div className={'data-item'}>
                        <h3>
                            <img src={user} alt="name"/>
                            {t('notifications.name')}
                        </h3>
                        <div>
                            <span className={'type'}>{t('notifications.owner')}</span>
                            <span>{` ` + tenantData.tenantListData?.OwnerName}</span>
                        </div>
                        <div>
                            <span className={'type'}>{t('notifications.renter')}</span>
                            <span>{` ` + tenantData?.tenantListData?.RenterName}</span>
                        </div>
                    </div>
                    <div className={'data-item'}>
                        <h3>
                            <img src={phone} alt="phone"/>
                            {t('notifications.phone')}
                        </h3>
                        <div>
                            <span>{tenantData?.tenantListData?.OwnerPhone}</span>
                        </div>
                        <div>
                            <span>{tenantData?.tenantListData?.RenterPhone}</span>
                        </div>
                    </div>
                    <div className={'data-item'}>
                        <h3>
                            <img src={mail} alt="mail" />
                            {t('notifications.email')}
                        </h3>
                        <div>
                            <span>{tenantData?.tenantListData?.OwnerEmail}</span>
                        </div>
                        <div>
                            <span>{tenantData?.tenantListData?.RenterEmail}</span>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </NotificationsModal>
    );
}
